import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { OpenBalanceTexts } from "../utils/openBalance-enums";
// Separated out the error texts so that they can be used in the multiple locations.
export const ErrorTexts = () => (_jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "h2", color: "error", gutterBottom: true }, { children: OpenBalanceTexts.ERROR_TITLE })), _jsx(Typography, { children: OpenBalanceTexts.ERROR_MESSAGE })] }));
